import './style.scss'

import { mapState } from 'vuex'

export default {
  name: 'Modal',
  props: {
    'id': {
      type: String,
      required: true
    }
  },
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.handleKeyDown(e)
      }
    })
  },
  methods: {
    handleModalClick (e, outside) {
      outside ? this.$store.dispatch('closeModal', { id: this.id }) : ''
    },
    handleButtonClick () {
      this.$store.dispatch('closeModal', { id: this.id })
    },
    handleKeyDown (e) {
      this.$store.dispatch('closeModal', { id: this.id })
    }
  },
  computed: {
    ...mapState(['ui']),
    isOpen () {
      return this.ui.modalOpen === this.id
    }
  },
  render (h) {
    const { isOpen } = this
    if (isOpen) {
      return (
        <transition name='Modal__transition'>
          <div class='Modal'>
            <div class='Modal__backdrop' onClick={(e) => this.handleModalClick(e, true)}/>
            <div class='Modal__wrapper'>
              <div class='Modal__container' onClick={(e) => this.handleModalClick(e, false)}>
                {this.$slots.default}
                <button class='Modal__button' onClick={this.handleButtonClick.bind(this)}>Schliessen</button>
              </div>
            </div>
          </div>
        </transition>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/Modal/index.js